import React from "react";
import {Icon, styled} from "@reside/ui";
import {Tooltip} from "../../../tooltip";

export const AlertIcon = styled(Icon)`
  color: ${({theme}) => theme.color.orange100};
`;

const StyledTooltip = styled(Tooltip)`
  cursor: default;
`;

export const PacketSizeLimitAlertIcon = () => (
  <StyledTooltip content="Packet size limit exceeded">
    <AlertIcon size={28} name="alert" />
  </StyledTooltip>
);
